'use client';

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { Sun, Moon, Monitor } from 'lucide-react';

/**
 * Small footer-area theme switcher. next-themes' state is only safe to read
 * after mount, so we render nothing on the server/first paint to avoid a
 * hydration mismatch.
 */
export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  return (
    <div className="theme-switcher">
      <button
        type="button"
        aria-label="Light mode"
        className={theme === 'light' ? 'active' : ''}
        onClick={() => setTheme('light')}
      >
        <Sun size={14} />
      </button>
      <button
        type="button"
        aria-label="Dark mode"
        className={theme === 'dark' ? 'active' : ''}
        onClick={() => setTheme('dark')}
      >
        <Moon size={14} />
      </button>
      <button
        type="button"
        aria-label="System mode"
        className={theme === 'system' ? 'active' : ''}
        onClick={() => setTheme('system')}
      >
        <Monitor size={14} />
      </button>
    </div>
  );
}
